import { useEffect, useRef } from "react";
import { ChevronLeft } from "lucide-react";
import { useSidebar } from "../context/SidebarContext";
import { BOTON_FLOTANTE_MOBILE } from "../chat-atlas/ui/estilosAgente";

/**
 * En el teléfono, el volver de una pantalla vive en la banda flotante del cascarón, en
 * lugar de su volver redondo (ADR-2026-09-12-el-agente-en-mobile-usa-la-banda-del-volver):
 * un segundo volver dentro de la página quedaría apilado debajo del primero. Es UNA
 * píldora blanca que dice a dónde va ("‹ Mi marca"), y no el volver con el texto suelto
 * al lado: la banda es transparente y el texto quedaba encima del contenido al scrollear.
 * No usa el historial, que puede venir de otro lado (un link, el chat).
 *
 * Lo usan las pantallas de subir productos de Mi marca —
 * ADR-2026-10-13-subir-productos-es-una-pantalla y
 * ADR-2026-10-13-subir-productos-pantalla-de-consejos.
 */
export function useVolverEnLaBanda(etiqueta: string, volver: () => void) {
  const volverRef = useRef(volver);
  volverRef.current = volver;
  const { setMobileHideBack, setMobileHeaderLeft } = useSidebar();
  useEffect(() => {
    setMobileHideBack(true);
    setMobileHeaderLeft(
      <button
        type="button"
        onClick={() => volverRef.current()}
        className={`${BOTON_FLOTANTE_MOBILE} pl-3 pr-5`}
      >
        <ChevronLeft className="h-6 w-6" strokeWidth={2} />
        {etiqueta}
      </button>,
    );
  }, [etiqueta, setMobileHideBack, setMobileHeaderLeft]);
  useEffect(
    () => () => {
      setMobileHideBack(false);
      setMobileHeaderLeft(null);
    },
    [setMobileHideBack, setMobileHeaderLeft],
  );
}
